import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const HAS_PAID_REST_LABEL_ID = 'hasPaidRest-label';

const PAID_REST_OPTIONS: { label: string; value: boolean }[] = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
];

const PaidRestFields: React.FC = () => {
    const { control, formState: { isSubmitting } } = useFormContext();

    return (
        <div className="space-y-4">
            <div>
                <span id={HAS_PAID_REST_LABEL_ID} className="block text-sm font-medium text-gray-700">
                    Tem direito a descanso remunerado (Acordo verbal)
                </span>
                <Controller
                    name="hasPaidRest"
                    control={control}
                    render={({ field }) => (
                        <div
                            role="radiogroup"
                            aria-labelledby={HAS_PAID_REST_LABEL_ID}
                            className="mt-2 flex items-center gap-4"
                        >
                            {PAID_REST_OPTIONS.map((option) => (
                                <label
                                    key={option.label}
                                    className="flex items-center gap-2 text-sm text-gray-900 cursor-pointer"
                                >
                                    <input
                                        type="radio"
                                        checked={field.value === option.value}
                                        onChange={() => field.onChange(option.value)}
                                        onBlur={field.onBlur}
                                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                        disabled={isSubmitting}
                                    />
                                    {option.label}
                                </label>
                            ))}
                        </div>
                    )}
                />
            </div>

            <div>
                <label htmlFor="paidRestObservations" className="block text-sm font-medium text-gray-700">
                    Observações
                </label>
                <Controller
                    name="paidRestObservations"
                    control={control}
                    render={({ field, fieldState }) => (
                        <>
                            <textarea
                                {...field}
                                value={field.value || ''}
                                id="paidRestObservations"
                                rows={2}
                                className="input-primary w-full mt-1"
                                placeholder="Observações sobre o descanso remunerado..."
                                disabled={isSubmitting}
                            />
                            {fieldState.error && (
                                <span className="text-red-500 text-sm mt-1">{fieldState.error.message}</span>
                            )}
                        </>
                    )}
                />
            </div>
        </div>
    );
};

export default PaidRestFields;
